import React from 'react';

export const TabNav = ({children}) => {
  const tabs = React.Children.map(children, (tab, i) => {
    return (
      <li
        key={'tab-' + (i)}
        style={{cursor:'pointer', display:'inline-block'}} >
        { tab }
      </li>
    );
  });

  return (
    <nav>
      <ul style={{margin:0, padding:0}}>
        { tabs }
      </ul>
    </nav>
  );
};




/** WEBPACK FOOTER **
 ** ./components/race/create/TabNav.js
 **/